import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { AutocompleteSxStyles } from './styles';

interface CustomAutocompleteProps {
    label: string;
    value: number | null;
    onChange: (newValue: number | null) => void;
    optionsList: string[];
    disabled?: boolean;
    // getOptionLabel?: (option: any) => string;
}

export const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({ label, value, onChange, optionsList, disabled }) => {
    return (
        <Autocomplete
            disablePortal
            options={optionsList}
            disableClearable
            // getOptionLabel={getOptionLabel}
            value={
                value !== null && value >= 0 && value < optionsList.length
                    ? optionsList[value]
                    : optionsList.length > 0
                    ? optionsList[0]
                    : null
            }
            onChange={(event, newValue) => {
                // Prevent clearing - if newValue is null, keep current value
                if (newValue === null) {
                    return;
                }
                // Call your simplified onChange handler with just the new value
                const selectedIndex = optionsList.indexOf(newValue);
                if (selectedIndex >= 0) {
                    onChange(selectedIndex);
                }
            }}
            sx={AutocompleteSxStyles()}
            renderInput={(params) => <TextField {...params} label={label} />}
            disabled={disabled}
        />
    );
};
